<script setup lang="ts">
import { useScreenSize } from "../../../utils/useScreenSize";
import { PaymentReceipts } from "../../../types/models";
import FilePreview from "../../../components/ui/form/FilePreview.vue";
import {
  formatNumber,
} from "../../../utils/CommonFunctions";
import { computed } from "vue";
const { isMobile } = useScreenSize();

const props = defineProps<{
  data?: PaymentReceipts[];
}>();

const total = computed(() => {
  return props.data?.reduce((sum: number, payment: PaymentReceipts) => sum + payment.amount, 0);
});
</script>

<template>
  <table
    v-if="data && data.length > 0"
    :class="[isMobile ? 'w-[350px]' : 'w-[500px]']"
  >
    <thead class="bg-white dark:bg-gray-900">
      <tr>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Ref No.
        </th>
        <th
          class="z-20 px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Payment Type
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Currency
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Amount
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Outlet
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          POS Station
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Reference
        </th>
        <th
          class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Attachment
        </th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
      <template v-for="payment in data" :key="payment.uid">
        <tr>
          <td class="px-4 py-3 text-left">
            {{ payment.document_no }}
          </td>
          <td class="px-4 py-3 text-left">
            {{ payment.payment_type }}
          </td>
          <td class="px-4 py-3 text-left">
            {{ payment.currency }}
          </td>
          <td class="px-4 py-3 text-right">
            {{ formatNumber(payment.amount) }}
          </td>
          <td class="px-4 py-3 text-left">
            {{ payment.outlet }}
          </td>
          <td class="px-4 py-3 text-left">
            {{ payment.pos_station }}
          </td>
          <td class="px-4 py-3 text-left">
            {{ payment.reference }}
          </td>
          <td class="px-4 py-3 text-left">
            <FilePreview :file="payment.attachment" />
          </td>
        </tr>
      </template>
    </tbody>
    <thead class="bg-white dark:bg-gray-900">
      <tr>
        <th
        colspan="3"
          class="z-20 px-4 py-3 text-left text-md font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          Total
        </th>
        <th
          class="px-4 py-3 text-right text-md font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
        >
          {{
            formatNumber(
              total
            )
          }}
        </th>
        <th colspan="4"></th>
      </tr>
    </thead>
  </table>
</template>
